import { PlatformApi } from '~/services/api/platform'

export class MaintenanceService extends PlatformApi {
  async getAll() {
    await this.get(`/maintenance/jobs`)
  }

  async getJob(jobId) {
    await this.get(`/maintenance/jobs/${jobId}`)
  }

  async getOpen() {
    await this.get(`/maintenance/jobs/open`)
  }

  async getClosed() {
    await this.get(`/maintenance/jobs/closed`)
  }

  async getRecentlyClosed() {
    await this.get(`/maintenance/jobs/closed/recent`)
  }

  async getRecentlyClosedForPaddock(paddockId) {
    await this.get(`/maintenance/jobs/closed?limit=5&page=0&paddock=${paddockId}`)
  }

  async createJob() {
    await this.post(`/maintenance/jobs`)
  }

  async updateJob(jobId) {
    await this.put(`/maintenance/jobs/${jobId}`)
  }

  async deleteJob(jobId) {
    await this.delete(`/maintenance/jobs/${jobId}`)
  }

  async sendUserReport() {
    await this.post(`/maintenance/user-report`)
  }

  async getNewCustomerReports() {
    await this.get(`/maintenance/user-report?status=submitted`)
  }

  async updateReport(reportId) {
    await this.put(`/maintenance/user-report/${reportId}`)
  }
}
